import { render, staticRenderFns } from "./Pos_invoice_Receipt.vue?vue&type=template&id=6a68eac7&scoped=true&"
import script from "./Pos_invoice_Receipt.vue?vue&type=script&lang=js&"
export * from "./Pos_invoice_Receipt.vue?vue&type=script&lang=js&"
import style0 from "./Pos_invoice_Receipt.vue?vue&type=style&index=0&id=6a68eac7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a68eac7",
  null
  
)

export default component.exports